import { createStorageAtomFactory, dedupe } from '@exodus/atoms'

const createAbTestingAtom = ({ storage }) => {
  const atomFactory = createStorageAtomFactory({ storage })

  return dedupe(
    atomFactory({
      key: 'data',
      defaultValue: { experiments: {}, variants: {} },
      isSoleWriter: true,
    })
  )
}

export default createAbTestingAtom
